import { PageNotFoundPath } from 'config/routersConstants';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, RouteProps } from 'react-router-dom';  
import { RootState } from 'store';

interface IOwnProps extends RouteProps {
  hasAnyAuthorities?: string[];
}

interface UserProps extends IOwnProps {
  user?: string,
  type?: number,
  login?: string,/***  Bug #598  @Author Anupama P  @Date 28 Aug 2021  */
}

export interface IPrivateRouteProps extends IOwnProps, StateProps, UserProps {}

export const PrivateRouteComponent = ({
  component: Component,
  isAuthenticated,
  sessionHasBeenFetched,
  
  hasAnyAuthorities = [],
  user,
  type,
  login,/***  Bug #598  @Author Anupama P  @Date 28 Aug 2021  */
  account,
  ...rest
}: IPrivateRouteProps) => {
  const checkAuthorities = props =>
  /*   isAuthorized ? (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    ) : (
      <div className="insufficient-authority">
        <div className="alert alert-danger">
          <Translate contentKey="error.http.403">You are not authorized to access this page.</Translate>
        </div>
      </div>
    ); */
    type !== account.type ?
    <Redirect
        to={{
          pathname: PageNotFoundPath.path,
          search: props.location.search,
          state: { from: props.location },
        }}
      />
    :
    Component ? /***  Bug #598  @Author Anupama P  @Date 28 Aug 2021  */
      <Component {...props} />
      :
      rest.children 
    
  const renderRedirect = props => {
    /**
    * Bug #472
    * @Author Aby Joseph
    * @Date 05 July 2021
    */   
    return isAuthenticated ? (
      checkAuthorities(props)
    ) : (
      <Redirect
        to={{
          pathname: login,/***  Bug #598  @Author Anupama P  @Date 28 Aug 2021  */
          search: props.location.search,
          state: { from: props.location },
        }}
      />
    );
    /*End - Bug#472*/
  };
/***  Bug #598  @Author Anupama P  @Date 28 Aug 2021  */
  if (!Component && !rest.children) throw new Error(`A component needs to be specified for private route for path ${(rest as any).path}`);

  return <Route {...rest} render={renderRedirect} />;
};

export const hasAnyAuthority = (authorities: string[], hasAnyAuthorities: string[]) => {
  if (authorities && authorities.length !== 0) {
    if (hasAnyAuthorities.length === 0) {
      return true;
    }
    return hasAnyAuthorities.some(auth => authorities.includes(auth));
  }
  return false;
};

const mapStateToProps = (
  { authentication: { isAuthenticated, account, sessionHasBeenFetched } }: RootState,
  { hasAnyAuthorities = [] }: IOwnProps
) => ({
  isAuthenticated,
  account,
 // isAuthorized: hasAnyAuthority(account.authorities, hasAnyAuthorities),
  sessionHasBeenFetched,
});

type StateProps = ReturnType<typeof mapStateToProps>;

/**
 * A route wrapped in an authentication check so that routing happens only when you are authenticated.
 * Accepts same props as React router Route.
 * The route also checks for authorization if hasAnyAuthorities is specified.
 */
export const PrivateRoute = connect(mapStateToProps, null, null, { pure: false })(PrivateRouteComponent);

export default PrivateRoute;
